import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerfectomyLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 87.6 79.68",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1-2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				style: { fill: "#5641fc" },
				d: "M15.4,79.68s-3.06-12.57-1.69-25.26c9.46-8.38,21.1-10.41,26.3-10.9-7.39,.88-27.06,6-24.61,36.17Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: { fill: "#5641fc" },
				d: "M67.78,43.29l-12.48,.02-12.56,.04h-.96c-19.53,.13-25.87,5.17-27.15,6.43-.13,.13-.21,.22-.25,.26,.29-1.55,.68-3.09,1.17-4.59,.47-1.45,1.03-2.86,1.69-4.2,.06-.14,.13-.27,.21-.41,5.76-12.12,19.47-12.61,19.47-12.61l28.94-.06c.15-.02,.32-.05,.47-.07,.05,0,.08-.01,.13-.02,.04,0,.07-.01,.12-.02,9.74-1.48,15.96-6.62,19.92-12.26,3.63,11.99-1.4,26.56-18.71,27.49Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: { fill: "#5641fc" },
				d: "M84.74,11.45c-4.46,10.97-14.09,15.49-17.74,16.5,2.36-.71,3.5-2.79,3.5-4.93h0c0-.72-.13-1.44-.39-2.12,0-.02-.01-.05-.02-.07-.01-.03-.02-.06-.04-.08-.02-.05-.03-.09-.06-.14h-.01c-.11-.25-.22-.48-.36-.7-.27-.44-.61-.86-1.02-1.21-.99-.91-2.4-1.51-4.19-1.49l-20.06,.05H19.34L0,.09l41.57-.09h26.2c.29,.01,.58,.03,.86,.07,.22,.01,.46,.03,.68,.07,.41,.05,.81,.11,1.19,.18,.47,.09,.92,.19,1.38,.32,.3,.08,.61,.16,.91,.27,1.27,.4,2.46,.93,3.6,1.58,.06,.03,.12,.07,.19,.11,.12,.07,.25,.14,.36,.22,.23,.15,.47,.3,.7,.44,.01,0,.01,.01,.02,.02,.22,.15,.44,.32,.67,.47t.02,.02c.22,.16,.43,.33,.64,.5,.01,.01,.01,.02,.01,.02,.08,.06,.16,.12,.23,.19,.13,.09,.25,.2,.36,.3,.22,.21,.44,.41,.67,.62,.26,.23,.5,.48,.74,.74,.23,.25,.47,.5,.69,.77,.21,.23,.42,.48,.61,.74,.22,.27,.43,.55,.63,.83,.09,.14,.2,.27,.29,.41h0c.11,.16,.2,.3,.29,.46,.18,.26,.34,.53,.51,.81,.02,.03,.05,.08,.08,.14,.22,.39,.44,.78,.64,1.18Z"
			})
		]
	})
});
export { SvgPerfectomyLogo as ReactComponent };
